const footer = {
  footer: {
    imageTitle: 'Odwiedź witrynę internetową Enphase Energy',
    privacy: 'Prywatność',
    terms: 'Warunki',
    enphaseText: '©2008-%{currentYear} Enphase Energy Inc. Wszelkie prawa zastrzeżone.',
    language: 'Język',
    production_ct: {
      verify_ct: "Sprawdź CT",
      checlist_nodata: "Brak wystarczających danych licznika do przeprowadzenia tej kontroli",
      production_meter_verification: "Weryfikacja licznika produkcji",
      serial_no: "Numer seryjny",
      polarity_check: "Sprawdź polaryzację",
      polarity_check_failed: "Kontrola polaryzacji nie powiodła się",
      ct_missing_branch_check: "Sprawdzanie, czy CT nie ma brakujących obwodów odgałęzionych",
      polarity_check_passed: "Sprawdzenie polaryzacji zakończone pomyślnie",
      ct_no_missing_branch_circuit: "CT nie ma brakujących obwodów odgałęzionych",
      incorrect_direction_or_phase_message: "Kierunek lub faza CT produkcji może być nieprawidłowa",
      hide_details: "Ukryj szczegóły",
      check_try_again: "Sprawdź poniższe i spróbuj ponownie",
      pv_on_for_5_min: "Upewnij się, że obwód fotowoltaiczny jest WŁĄCZONY i działa od co najmniej 5 minut",
      l1_wires_production_ct_message: "Sprawdź, czy tylko przewody L1 przechodzą przez CT produkcji, a przepływ produkcji jest zgodny z kierunkiem strzałki CT od PV do wyłącznika",
      blue_white_wires_position_message: "Upewnij się, że niebieski i biały przewód są podłączone we właściwych miejscach w listwie zaciskowej Envoy",
      wires_include_pv_generation_not_load_storage: "Upewnij się, że przewody biegnące przez produkcyjny CT obejmują tylko generowanie PV (bez obciążeń lub magazynowania)",
      l1_a_correct_phase_message: "Upewnij się, że prawidłowa faza, tj. L1(a), przechodzi przez produkcyjny CT",
      l1_phase_consistency_check_message: "Sprawdź zgodność faz L1 za pomocą miernika cyfrowego i upewnij się, że L1 obwodów PV i L1 w Envoy są w tej samej fazie",
      missing_branch_warning: "CT produkcji może mieć brakujące obwody odgałęzione",
      test_only_valid_for_sunshine_hours: "Ten test jest ważny tylko w godzinach nasłonecznienia",
      reading_lower_than_expected: "Odczyty produkcyjne są niższe niż oczekiwano. Sprawdź następujące elementy, a następnie stuknij i spróbuj ponownie",
      wires_include_all_pv_generation: "Upewnij się, że przewód przechodzący przez produkcyjny CT obejmuje wszystkie obwody generacji PV",
      branch_circuit_reverse_check: "Upewnij się, że żaden z obwodów odgałęzionych nie przechodzi przez przekładnik prądowy w odwrotnej kolejności",
      storage_load_circuits_through_production_ct: "Upewnij się, że przez produkcyjny CT przechodzą obwody przechowywania lub obciążenia",
      show_details: "Pokaż szczegóły",
      verify_ct_not_supported_for_device: "Weryfikacja przekładników (CT) nie jest obsługiwana przez to urządzenie",
      verify_ct_timeStamp: "Sprawdzone na",
      verify_ct_systemID: "identyfikator systemu",
      prodct_reversepolarity_text: "Kierunek lub faza CT produkcji może być nieprawidłowa",
      prodct_reverse_polarity_btn: "Odwróć polaryzację",
      verify_ct_timeout: "Żądanie zostało przerwane. Proszę spróbować ponownie"
    }
  }
};

export default footer;
